import { GenericHttpClient } from "./config/http.generic.client";

// Creating a conversation is by far the longest-running widget request: the
// server also runs the project's "on conversation started" workflow (greeting,
// answer-bot setup, agent engagement) before it responds. Measured server-side
// it is ~0.4s at p50 but 7s+ at p99, so the 4s default aborted roughly 1% of
// all conversation starts — the customer sat on the loading shell while the
// server happily finished creating the conversation.
const CREATE_CONVERSATION_TIMEOUT = 30000;

export class HttpTicketService extends GenericHttpClient<any> {
  static _instance: HttpTicketService;
  static getInstance(): HttpTicketService {
    if (this._instance == null) {
      this._instance = new HttpTicketService("/v3/shared/tickets");
    }
    return this._instance;
  }

  /**
   * Create a conversation. Not routed through the generic `create()` because it
   * needs the longer timeout above and must NOT be retried: an aborted create
   * is usually still processed server-side, so a retry leaves the customer with
   * a duplicate (empty) conversation in their inbox for every attempt.
   */
  async createConversation(data: any) {
    const response = await this.post(this.path, data, {
      timeout: CREATE_CONVERSATION_TIMEOUT,
      retry: false,
    });

    return response.data;
  }

  async indicateTyping(args: { ticketShareToken: string; typing: boolean }) {
    const { ticketShareToken, typing } = args;

    return this.post(`${this.path}/${ticketShareToken}/typing`, {
      typing,
    });
  }

  async answerWorkflow(args: { ticketShareToken: string; data: any }) {
    const { ticketShareToken, data } = args;

    return this.post(`${this.path}/${ticketShareToken}/workflow/answer`, {
      ...data,
    });
  }

  async joinVideoCall(args: {
    meetingId: string;
    gleapId?: string;
  }) {
    const { meetingId, gleapId } = args;

    const response = await this.post(`/v3/shared/video-calls/join`, {
      meetingId,
      gleapId,
    });

    return response.data;
  }
}
